export default __webpack_public_path__ + "static/media/kiotviet.8ce4a6ea.png";